import { AspectRatio, Image } from '@mantine/core'
import { Match } from '../../matches/api'
import { RingLoader } from '../Round/RingLoader'
import classes from './MatchScoreCard.module.css'

export default function MatchScoreCard({ match }: { match: Match }) {
  const awayLabel = match.away_team_id == null ? 'BYE' : match.away_team_name
  const isLive = match.round_status === 'live'

  return (
    <div className={classes.card}>
      <div className={classes.midBand} />

      <div className={classes.grid}>
        <div className={classes.team}>
          <div className={classes.logoWrapper}>
            <AspectRatio ratio={1}>
              <Image
                src={match.home_team_logo.thumbnail}
                alt={match.home_team_name}
                fit="contain"
              />
            </AspectRatio>
          </div>
          <div className={classes.teamName}>{match.home_team_name}</div>
        </div>

        <div className={classes.scoreboard}>
          <div className={classes.gradientPanel}>
            <div className={classes.scoreLabel}>Score</div>
            <div className={classes.scoreValue}>
              {match.home_team_score} : {match.away_team_score}
            </div>
          </div>
          <div className={classes.fullTimePillWrap}>
            <div className={classes.fullTimePill}>
              {isLive ? (
                <span className={classes.livePill}>
                  <RingLoader style={{ width: '1.5em', height: '1.5em' }} />
                  Live
                </span>
              ) : (
                'Full-Time'
              )}
            </div>
          </div>
        </div>

        <div className={classes.team}>
          <div className={classes.logoWrapper}>
            <AspectRatio ratio={1}>
              <Image
                src={match.away_team_logo.thumbnail}
                alt={awayLabel}
                fit="contain"
              />
            </AspectRatio>
          </div>
          <div className={classes.teamName}>{awayLabel}</div>
        </div>
      </div>
    </div>
  )
}
